(function () {
  'use strict';
  document.querySelectorAll('[data-ds-product-lab-root]').forEach(function (root) {
    if (root.dataset.ready === 'true') return;
    var link = root.querySelector('[data-ds-product-lab]');
    var data = root.querySelector('[data-ds-lab-variants]');
    if (!link || !data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    root.dataset.ready = 'true';
    var section = root.closest('.product_section') || root.closest('[data-product-id]') || document;
    var gallery = section.querySelector('.product_gallery');
    var galleryFrame = 0;

    function variantInput() {
      return section.querySelector('form[action*="/cart/add"] [name="id"]');
    }
    function sync(preferGallery) {
      var input = variantInput();
      var variant = variants[input && input.value] || variants[root.dataset.defaultVariant];
      if (preferGallery === true || !input || !input.value) {
        var magic = section.querySelector('.MagicToolboxSelectorsContainer .mz-thumb-selected[data-variants]');
        var image = gallery && gallery.querySelector('.slides > .flex-active-slide img[data-image-id]');
        var imageId = image && image.dataset.imageId;
        var candidates = magic ? magic.dataset.variants.split(',').filter(function (key) { return !!variants[key]; })
          : Object.keys(variants).filter(function (key) { return imageId && variants[key].imageId === imageId; });
        var selectors = section.querySelectorAll('.single-option-selector');
        var id = candidates.indexOf(input && input.value) !== -1 ? input.value : candidates.find(function (key) {
          return Array.prototype.every.call(selectors, function (selector, index) {
            return index === 0 || !selector.value || variants[key].options[index] === selector.value;
          });
        }) || candidates[0];
        if (id) variant = variants[id];
      }
      if (!variant || !/^[A-Za-z0-9_-]{1,12000}$/.test(variant.token || '')) return;
      link.dataset.labBuild = variant.token;
      link.href = '#build=' + variant.token;
      link.setAttribute('aria-label', 'View ' + variant.label + ' in 3D');
    }
    function syncGallery() {
      galleryFrame = 0;
      var input = variantInput();
      var magic = section.querySelector('.MagicToolboxSelectorsContainer .mz-thumb-selected[data-variants]');
      var image = gallery && gallery.querySelector('.slides > .flex-active-slide img[data-image-id]');
      if (!magic && !image) return;
      var imageId = image && image.dataset.imageId;
      var current = input && variants[input.value];
      var candidates = magic
        ? magic.dataset.variants.split(',').filter(function (key) { return !!variants[key]; })
        : Object.keys(variants).filter(function (key) { return variants[key].imageId === imageId; });
      var selectors = section.querySelectorAll('.single-option-selector');
      // Shared color photos must not reset a separately selected panel/size.
      var id = candidates.indexOf(input && input.value) !== -1 ? input.value : candidates.find(function (key) {
        return Array.prototype.every.call(selectors, function (selector, index) {
          return index === 0 || !selector.value || variants[key].options[index] === selector.value;
        });
      }) || candidates[0];
      if (input && input.value === id) { sync(); return; }
      if (!id || !input) return; // An unassigned lifestyle image is not a color choice.
      var variant = variants[id];
      // Use the theme's option selectors so price, purchase variant, image,
      // variant URL, and the Lab button all follow the same selected color.
      if (selectors.length && variant.options && selectors.length === variant.options.length) {
        selectors.forEach(function (selector, index) {
          if (selector.value === variant.options[index]) return;
          selector.value = variant.options[index];
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } else if (input.value !== id) {
        input.value = id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync(true);
    }
    function queueGallerySync() {
      if (!galleryFrame) galleryFrame = window.requestAnimationFrame(syncGallery);
    }
    if (gallery || section.querySelector('.MagicToolboxSelectorsContainer')) {
      new MutationObserver(function (records) {
        if (records.some(function (record) {
          return record.target.matches('.slides > li, .MagicToolboxSelectorsContainer [data-variants]');
        })) queueGallerySync();
      }).observe(section, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    link.addEventListener('pointerdown', function () { syncGallery(); sync(true); });
    link.addEventListener('click', function () { syncGallery(); sync(true); });
    section.addEventListener('change', function () { sync(); window.requestAnimationFrame(sync); });
    document.addEventListener('variant:change', sync);
    sync();
  });
})();
